// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32t1b","type":"styles_type__3ewvs","choices":"styles_choices__1pyBn"};